import axios from 'axios'

export default {
  methods: {
    initCancelToken(token) {
      // Cancel previous request
      if (token)
        token.cancel();

      return axios.CancelToken.source();
    }
  }
}
